var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import { H2, Flex, Hr, Link } from '@tpr/core';
import StatusIcon from './StatusIcon';
import styles from '../sidebar.module.scss';
var SidebarMenu = function (_a) {
    var title = _a.title, links = _a.links, maintenanceMode = _a.maintenanceMode, collapsed = _a.collapsed, sectionCompleteLabel = _a.sectionCompleteLabel, sectionIncompleteLabel = _a.sectionIncompleteLabel;
    var collapsedClass = styles.nestedWrapper + ' ' + styles.collapsed;
    var _b = useState(styles.nestedWrapper), classes = _b[0], setClasses = _b[1];
    useEffect(function () {
        collapsed && setClasses(collapsedClass);
        !collapsed && setClasses(styles.nestedWrapper);
    }, [collapsed]);
    var generateSubmenu = function (links) {
        return (React.createElement(Flex, { cfg: { flexDirection: 'column', pl: 6 }, className: classes },
            React.createElement("ul", { className: styles.list }, links.map(function (_a, key) {
                var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, _c = _a.active, active = _c === void 0 ? function () { return false; } : _c, innerLink = __rest(_a, ["onClick", "active"]);
                return (React.createElement("li", { key: key },
                    React.createElement(Flex, { cfg: { justifyContent: 'space-between', mb: links ? 5 : 1 }, className: styles.nested, "aria-current": active(innerLink.path, true) ? 'page' : null },
                        React.createElement(Link, { cfg: {
                                color: 'primary.2',
                                textAlign: 'left',
                                fontWeight: 3,
                                width: innerLink.hideIcon ? 10 : 8,
                            }, disabled: innerLink.disabled, onClick: function () { return onClick(innerLink); } },
                            React.createElement(Flex, { cfg: {
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                } },
                                React.createElement("span", null, innerLink.name),
                                !maintenanceMode && !innerLink.hideIcon && (React.createElement(StatusIcon, { link: innerLink, sectionCompleteLabel: sectionCompleteLabel, sectionIncompleteLabel: sectionIncompleteLabel }))))),
                    innerLink.links && generateSubmenu(innerLink.links)));
            }))));
    };
    return (React.createElement(Flex, { cfg: { flexDirection: 'column' }, className: styles.sidebarMenu },
        React.createElement(H2, { cfg: { fontWeight: 3, mt: 4, color: 'neutral.8', lineHeight: 6 }, className: styles.styledAsH3 }, title),
        React.createElement(Hr, { cfg: { my: 4 } }),
        React.createElement("ul", { className: styles.list }, links.map(function (_a, key) {
            var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, _c = _a.active, active = _c === void 0 ? function () { return false; } : _c, link = __rest(_a, ["onClick", "active"]);
            return (React.createElement("li", { key: key },
                React.createElement(Flex, { cfg: {
                        justifyContent: 'space-between',
                        mb: link.links ? 1 : 5,
                        flexDirection: link.links ? 'column' : 'row',
                    }, className: active(link.path, false)
                        ? styles.topLevelWrapper + " " + styles.containsSelectedLink
                        : styles.topLevelWrapper },
                    React.createElement(Flex, { cfg: {
                            justifyContent: 'space-between',
                            width: 10,
                            mb: link.links ? 5 : 1,
                        }, className: styles.topLevelLink, "aria-current": active(link.path, true) ? 'page' : null },
                        React.createElement(Link, { cfg: {
                                color: 'primary.2',
                                textAlign: 'left',
                                fontWeight: 3,
                                width: link.hideIcon ? 10 : 8,
                            }, disabled: link.disabled, onClick: function () { return onClick(link); } },
                            React.createElement(Flex, { cfg: {
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                } },
                                React.createElement("span", null, link.name),
                                !maintenanceMode && !link.hideIcon && (React.createElement(StatusIcon, { link: link, sectionCompleteLabel: sectionCompleteLabel, sectionIncompleteLabel: sectionIncompleteLabel }))))),
                    link.links &&
                        link.links.length > 0 &&
                        generateSubmenu(link.links))));
        }))));
};
export default React.memo(SidebarMenu);
//# sourceMappingURL=SidebarMenu.js.map